<section class="contact-section" id="contact">
  <img
    class="contact-section__logo"
    src="/contact_logo.svg"
    alt="Sitco">

  <div class="contact-section__content">
    <h2 class="contact-section__title">
      Ready to start?<br>
      Enter your email &amp; name
    </h2>

    <form
      class="contact-form"
      (ngSubmit)="nextContactStep()"
      novalidate>

      <div class="contact-form__field">
        <input
          *ngIf="contactStep === 'name'"
          class="contact-form__input"
          type="text"
          name="contactName"
          autocomplete="name"
          placeholder="Name"
          aria-label="Name"
          [(ngModel)]="contactName">

        <input
          *ngIf="contactStep === 'email'"
          class="contact-form__input"
          type="email"
          name="contactEmail"
          autocomplete="email"
          placeholder="Email"
          aria-label="Email"
          [(ngModel)]="contactEmail">

        <button
          class="contact-form__button"
          type="submit"
          [attr.aria-label]="
            contactStep === 'name'
              ? 'Continue to email'
              : 'Complete form'
          ">
          <span
            class="contact-form__arrow contact-form__arrow--current"
            aria-hidden="true"></span>
          <span
            class="contact-form__arrow contact-form__arrow--next"
            aria-hidden="true"></span>
        </button>
      </div>
    </form>
  </div>
</section>
